import { useState, useContext } from 'react';
import Spinner from '../../reusable/spinner/spinner.component';
import AddImage from '../../reusable/images/add-image/add-image.component';
import { ToastContext } from '../../../contexts/toast.context';

import {
  AddNoteContainer,
  NewNoteContainer,
  AddNoteInput,
  AddNoteTextarea,
  AddNoteButton,
  AddNoteField,
  AddNoteCheckboxLabel,
  AddNoteLabel
} from './add-note.styles';

const AddNote = ({ onSubmit, showPublicToggle = true, defaultType = '' }) => {
  const [loading, setLoading] = useState(false);

  const [content, setContent] = useState('');
  const [type, setType] = useState(defaultType);
  const [isPublic, setIsPublic] = useState(false);
  const [metadata, setMetadata] = useState('');
  const [image, setImage] = useState(null);

  const { errorToast } = useContext(ToastContext);

  const submitNote = async () => {
    if (!content.trim()) {
      errorToast('Please enter note content.');
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('content', content);
      formData.append('type', type);
      formData.append('isPublic', isPublic);
      formData.append('metadata', metadata);

      if (image) {
        formData.append('files', image); // NOTE: 'files' matches multer array field name
      }

      // `onSubmit` must handle sending FormData to the correct endpoint
      await onSubmit(formData);

      // setContent('');
      // setType(defaultType);
      // setIsPublic(false);
      // setMetadata('');
      // setImage(null);
    } catch (err) {
      console.error('Note submission failed:', err);
      errorToast('Failed to add note. Try again.');
    }

    setLoading(false);
  };

  return (
    <AddNoteContainer>
      {loading ? (
        <Spinner />
      ) : (
        <NewNoteContainer>
          <AddNoteField>
            <AddNoteLabel htmlFor="note-content">Content:</AddNoteLabel>
            <AddNoteTextarea
              id="note-content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Write your note here..."
            />
          </AddNoteField>

          <AddNoteField>
            <AddNoteLabel htmlFor="note-type">Type:</AddNoteLabel>
            <AddNoteInput
              id="note-type"
              value={type}
              onChange={(e) => setType(e.target.value)}
              placeholder="Optional type (e.g., admin, alert, flag)"
            />
          </AddNoteField>

          {showPublicToggle && (
            <AddNoteCheckboxLabel>
              <input
                type="checkbox"
                checked={isPublic}
                onChange={(e) => setIsPublic(e.target.checked)}
              />
              Make Public
            </AddNoteCheckboxLabel>
          )}

          <AddNoteField>
            <AddNoteLabel>Attach Image (optional)</AddNoteLabel>
            <AddImage
              image={image}
              setImage={setImage}
              showSaveButton={false}
            />
          </AddNoteField>

          <AddNoteButton onClick={submitNote}>Add Note</AddNoteButton>
        </NewNoteContainer>
      )}
    </AddNoteContainer>
  );
};

export default AddNote;